import {Box, Colors} from '@dagster-io/ui-components';
import clsx from 'clsx';
import {ComponentProps} from 'react';

import styles from '@/components/css/Card.module.css';

interface Props extends ComponentProps<typeof Box> {
  responsive?: boolean;
}

export default function Card({children, responsive = false, className, ...rest}: Props) {
  return (
    <Box
      className={clsx(className, styles.card, responsive && styles.responsiveCard)}
      padding={24}
      background={Colors.backgroundDefault()}
      {...rest}
    >
      {children}
    </Box>
  );
}
